import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core';

import ProjectPicker from './Project/ProjectPicker';
import PageToggleButtonGroup from './PageToggleButtonGroup';
import Notifications from './Notifications';
import Profile from './Profile';
import PreferencesInfo from './PreferencesInfo';

const propTypes = {
  lite: PropTypes.bool
};

const defaultProps = {
  lite: false
};

const useStyles = makeStyles(theme => styles(theme));

function Header({ lite }) {
  const classes = useStyles();
  const features = useSelector(state => state.user.features);

  return (
    <div className={classes.root}>
      <img
        src="https://landhawk.s3.eu-west-1.amazonaws.com/logos/lh-logo.svg"
        className={classes.logo}
        onClick={e => window.location.replace('/')}
      />
      {!lite && (
        <div className={classes.rightSide}>
          {Boolean(features.preferences && features.preferences.showInHeader) && (
            <PreferencesInfo />
          )}
          {Boolean(features.projects && features.projects.enabled) && (
            <ProjectPicker />
          )}
          {Boolean(features.dashboard && features.dashboard.enabled) && (
            <PageToggleButtonGroup />
          )}
          <Notifications />
        </div>
      )}
      <Profile />
    </div>
  );
}

const styles = theme => ({
  root: {
    height: '46px',
    margin: '14px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  iconContainer: {
    height: '100%',
    width: theme.constants.sidebarNavigationWidth,
    textAlign: 'center'
  },
  icon: {
    width: '32px',
    height: '100%',
    boxSizing: 'border-box',
    color: theme.palette.primary.light,
    '& svg': {
      width: '32px',
      height: '40px'
    }
  },
  text: {
    letterSpacing: 0,
    fontWeight: 700,
    fontSize: '33px',
    lineHeight: '38px'
  },
  logo: {
    marginRight: 'auto',
    cursor: 'pointer',
    paddingLeft: '15px'
  },
  beta: {
    border: '1px solid #DBE8EA',
    borderRadius: 5,
    color: theme.palette.text.primary,
    padding: '3px 6px',
    marginLeft: 10
  },
  link: {
    marginLeft: 'auto',
    marginRight: 'auto',
    color: theme.palette.primary.light,
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      fontSize: '12px'
    }
  },
  rightSide: {
    display: 'flex',
    columnGap: '20px'
  }
});

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
